<template>
  <section class="card" :style="{'--span': span}">
    <header v-if="title" class="card-header">
      <h3 class="card-title">{{ title }}</h3>
      <p v-if="subtitle" class="card-subtitle">{{ subtitle }}</p>
    </header>
    <div v-if="empty" class="card-empty">Aucune donnée sur la période sélectionnée</div>
    <slot v-else />
  </section>
</template>

<script>
/**
 * Encadré d'un graphique ou d'un tableau de la page des statistiques.
 * span : largeur sur 12 colonnes (sur petit écran, toujours la largeur entière).
 */
export default {
  name: 'StatisticsCard',
  props: {
    title: {type: String, default: ''},
    subtitle: {type: String, default: ''},
    span: {type: Number, default: 6},
    empty: {type: Boolean, default: false},
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.card
  grid-column span var(--span)
  min-width 0
  padding 20px 22px 18px
  background white
  border 1px solid PAGE_RULE
  border-radius 16px
  box-shadow 0 1px 0 rgba(23, 35, 63, .04), 0 12px 28px -20px rgba(23, 35, 63, .4)

  @media (max-width: DESKTOP_SIZE)
    grid-column span 12

.card-header
  margin-bottom 14px

.card-title
  margin 0
  font-size 15px
  font-weight 700
  color THEME_COLOR_PRIMARY

.card-subtitle
  margin 3px 0 0
  font-size 12.5px
  color CTRL_TEXT_MUTED

.card-empty
  display flex
  align-items center
  justify-content center
  min-height 140px
  font-size 13px
  color CTRL_PLACEHOLDER
</style>
